export default {
  "top.head.title": "LINK-J | Life Science Innovation Network Japan",
  "top.head.description":
    "LINK-J, a Tokyo-based association established by Mitsui Fudosan, industry and academic volunteers to promote open innovation in the life science field, build an innovative ecosystem, and support the creation of new industries through industry-government-academia collaboration. Based in Tokyo’s Nihonbashi area, which serves as a hub for pharmaceutical-related enterprises, LINK-J aims to facilitate creation of new industries by promoting open innovation in the life sciences realm through industry-government-academia cooperation.",
  "top.recommended.title": "Recommended Articles",
  "top.event.title": "Events",
  "top.event.list.link": "All Events",
  "top.news.list.link": "",
  "top.bbt.event.title": "",
  "top.bbt.event.list.link": "",
  "top.newsletter.head1": "Get the LINK-J's",
  "top.newsletter.head2": "Latest Event Information",
  "top.newsletter.head3": "",
  "top.newsletter.link": "Subscribe to LINK-J Event News",
  "top.report.title": "Event Reports",
  "top.bbt.report.title": "Reports",
  "top.report.list.link": "All Event Reports",
  "top.bbt.report.list.link": "All Reports",
  "top.program.title": "Programs",
  "top.program.outOfBox.title": "Out of Box Consulting Room",
  "top.program.outOfBox.description":
    "Out of Box Consulting Room is a support program for the people who aim to gain the practical use of research.  You will be able to develop your idea with the experts from various fields.  No reservation needed and free of charge.",
  "top.program.unikorn.title": "UNIKORN",
  "top.program.unikorn.description":
    "To support & foster business expansion of Japanese life science startups into UK/EU market byconnecting them with experts and professionals.",
  "top.program.linkBioBay.title": "LINK-BioBAY TOKYO",
  "top.program.linkBioBay.description":
    "Fostering the creation of enterprises that make global leaps forward. Supporting start-ups by utilizing the expertise of domestic and international players.",
  "top.interview.title": "Interviews & Blogs",
  "top.interview.list.link": "All Interviews & Blogs",
  "top.news.title": "News",
  "top.news.category.all": "View All",
  "top.bulletinboard.title": "The Shared Bulletin Board",
  "top.bulletinboard.list.link": "The Shared Bulletin Board",
  "top.bulletinboard.head1": "Go to LINK-J's",
  "top.bulletinboard.head2": "Bulletin boards",
  "top.aboutUs.title": "About us",
  "top.aboutUs.linkjMovie.title": "LINK-J Movie",
  "top.aboutUs.linkjMovie.description":
    "LINK-The latest movies of LINK-J will be regularly updated.",
  "top.aboutUs.chairmanMessage.title": "Message from the Chairman of the Board",
  "top.aboutUs.chairmanMessage.description":
    "Chairman of the Board, Hideyuki Okano, M.D., Ph.D., Life Science Innovation Network Japan. (LINK-J) ",
  "top.aboutUs.oversea.title": "Overseas Collaborations",
  "top.aboutUs.oversea.description1":
    "From overseas to Japan, and from Japan to overseas: Spurring innovation through mutual collaboration",
  "top.aboutUs.oversea.description2": "",
  "top.aboutUs.link.why": "Why in Nihonbashi",
  "top.aboutUs.link.west": "What’s LINK-J WEST​",
  "top.aboutUs.link.message": "Messages of Support",
  "top.aboutUs.link.supporter": "Supporters",
  "top.aboutUs.link.company": "Our Activities",
  "top.aboutUs.link.organization": "Organization",
  "top.specialMemberSignUp.title": "Special Members",
  "top.specialMemberSignUp.link.existing": "About Special Membership",
  "top.specialMemberSignUp.link.subscription": "Membership Application",
  "top.specialMemberSignUp.link.list": "List of Special Members",
  "top.facilities.title": "Facilities",
  "top.facilities.link.room": "Lounges and Conference rooms",
  "top.facilities.link.office": "Offices and Laboratory",
  "top.facilities.link.access": "Access",
  "top.bbt.head.title": "",
  "top.bbt.head.description": "",
} as const;
